module.exports = __webpack_public_path__ + "static/media/trophy-silver.e38a26b9.svg";